import React, {
    useEffect,
    useState,
    useMemo, useContext, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import UserContext from "./UserContext";
import axios from "axios";
import AuthContext from "../AuthContext";


const UserContextProvider = ({
                                 children,
                             }) => {
    const [userClaims, setUserClaims] = useState(null)
    const [userName, setUserName] = useState(null)
    const [userMail, setUserMail] = useState(null)

    const [userPicture, setUserPicture] = useState(null)
    const [userPhone, setUserPhone] = useState(null)
    const [userProvince,setUserProvince] = useState(null)
    const [isReady, setIsReady] = useState(false);

    const {authToken, isMaster} = useContext(AuthContext)

    const [open, setOpen] = useState(false)

    const togleSideNav = useCallback(() => {
        setOpen(!open)
    }, [open]);

    useEffect(() => {

        let shouldUpdate = true;

        const init = async () => {
            setOpen(open)
            let url = process.env.REACT_APP_BACK_SERVER + '/u/consultarDatosUsuario'

            axios.post(url, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                }
            }).then((resp) => {
                // console.log(resp)
                if (shouldUpdate) {
                    setUserName(resp['data']['name'])
                    setUserMail(resp['data']['email'])
                    setUserPhone(resp['data']['phone'])
                    setUserPicture(resp['data']['picture'])
                    setUserProvince(resp['data']['province'])
                    {
                        isMaster && setUserClaims("master")
                    }
                    setIsReady(true);
                }
            })
        }

        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };
    }, [authToken])

    const context = useMemo(() => ({
        userClaims,
        userName,
        userMail,
        userProvince,
        open,
        togleSideNav,
        // userToken,
        userPhone,
        userPicture,
        // tokenUser,
        isReady
    }), [
        userClaims,
        userName,
        userMail,
        userProvince,
        open,
        togleSideNav,
        // userToken,
        userPhone,
        userPicture,
        // tokenUser,
        isReady
    ]);
    return (
        <UserContext.Provider value={context}>
            {children}
        </UserContext.Provider>
    );
};

UserContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default UserContextProvider;